'use client';

import Image from 'next/image';

import Award from '@public/png/award.png';

const GoldenProperty = () => {
  return (
    <div className="relative overflow-hidden bg-[radial-gradient(44.36%_50%_at_50%_97.25%,_#14045F_0%,_#040704_100%)] border-b-[0.5px] border-dashed border-[#040704] py-4">
      <div className="relative max-w-[1344px] my-0 mx-auto ">
        <Image
          src={Award}
          alt="Award"
          width={1000}
          height={1000}
          className="absolute top-[-97px] left-0 opacity-10 object-contain w-[307.771px] h-[335px]"
        />
        <div
          className="flex items-center justify-center gap-2 
                    dd2-xl:flex-col"
        >
          <p
            className="text-[14px]/[19.6px] font-satoshi text-[#FAFAFA] 
                     dd2-xl:text-center"
          >
            Century 21 Indonesia is recognized as:
          </p>
          <Image
            src={Award}
            alt="Award"
            width={1000}
            height={1000}
            className="object-contain w-[58.798px] h-[64px]"
          />
          <div>
            <p
              className="text-[17px]/[23.8px] font-satoshi-bold text-[#FAFAFA] 
                         dd2-xl:text-center"
            >
              Best Choice International Property Agent
            </p>
            <p
              className="text-[14px]/[19.6px] font-satoshi text-[#FAFAFA] 
                         dd2-xl:text-center"
            >
              Awarded by Golden Property Awards
            </p>
          </div>
        </div>
        <Image
          src={Award}
          alt="Award"
          width={1000}
          height={1000}
          className="absolute bottom-[-46px] right-0 opacity-10 object-contain w-[449.254px] h-[489px]"
        />
      </div>
    </div>
  );
};

export default GoldenProperty;
